(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmActivity', CrmActivity);

    CrmActivity.$inject = ['$resource'];

    function CrmActivity ($resource) {
        var resourceUrl =  'api/crm-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-activities/filter', method: 'GET', isArray: true}
        });
    }
})();
